import axios from "axios";

const fileConfig = {
    headers: {
        'Content-Type': 'multipart/form-data'
    }
}

export default {
    namespaced: true,
    state: {
        sizeLimit: 10,      // MB
        countLimit: 1,
        isMultiple: false,
        files: null,
        isSubmitted: false
    },
    getters: {
        getFiles: (state) => state.files,
        getSizeLimit: (state) => state.sizeLimit,
        getCountLimit: (state) => state.countLimit,
        getMultiple: (state) => state.isMultiple,
        getIsSubmitted: (state) => state.isSubmitted,
    },
    mutations: {
        SET_SUBMITTED(state, payload) {
            state.isSubmitted = payload
        },
        SET_FILES(state, payload) {
            state.files = payload
        },
        SET_MULTIPLE(state, payload) {
            state.isMultiple = payload
        },
        SET_SIZE_LIMIT(state, payload) {
            state.sizeLimit = payload
        },
        SET_COUNT_LIMIT(state, payload) {
            state.countLimit = payload
        },
    },
    actions: {
        UPLOAD_FILES({ state }, { type, files }) {
            const formData = new FormData()

            formData.append("type", type);
            formData.append("files", files);

            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/order-product-variant-file/upload`, formData, fileConfig)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
        DELETE_FILES({ state }, id) {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/api/order-product-variant-file/delete/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },
    }
}
